import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
    accordion_details:{
        display: 'block',
        width: '100%',
        height: 'auto',
        visibility: 'visible'
    },
    closed:{
        maxHeight: 0,
        overflow: 'hidden',
        visibility: 'hidden'
    },
    button_container:{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        paddingBottom: '2.5rem'
    },
    extended_rules:{
        maxWidth: 'unset',
        '& p': {
            fontSize: '1rem',
            height: 'auto',
            margin: '0 auto',
            textAlign: 'left',
            width: '91%',
            [theme.breakpoints.up(theme.breakpoints.values.md)]:{
                width: '93%',
            },
            [theme.breakpoints.up(theme.breakpoints.values.lg)]:{
                width: '62.7%',
                fontSize: '1.25rem'
            }
        }
    }
}));
